jQuery(window).scroll(function($) {
  console.log('The page is scrolling');
});